import qs from 'qs'
import _last from 'lodash/last'

import routes from 'app/routes'
import {
  getHomeSubscriptonInfo,
  getHomeFullSubscriptonInfo,
} from 'features/home/utils'

import { JobWithHomeType } from './types'
import { DOMAINS_QUERY_PARAM_SHORTCUT } from './consts'

export const createDomainQueryParams = (path: string[]) => {
  return qs.stringify(
    { [DOMAINS_QUERY_PARAM_SHORTCUT]: path },
    { encode: false }
  )
}

export const createHomeUrl = (rootId: string | null, homeId: string) => {
  return rootId ? `/${rootId}${routes.home}/${homeId}` : '/'
}

export const createJobUrl = (rootId: string | null, jobId: string) => {
  return rootId ? `/${rootId}/jobs/${jobId}` : '/'
}

// While app is working we may assume rootDomainId is always string
export const getCurrentSelectedDomain = (
  rootDomainId: string | null,
  domainQuery: string[]
): string => {
  return _last(domainQuery) || rootDomainId || ''
}

export const getSubscriptionInfo = (job: JobWithHomeType) => {
  const home = job.homes[0]
  return getHomeSubscriptonInfo(home)
}

export const getFullSubscriptionInfo = (job: JobWithHomeType) => {
  const home = job.homes[0]
  return getHomeFullSubscriptonInfo(home)
}
